import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/mobile-app/page.tsx");
